import React from 'react';
import SignatureCanvas from './SignatureCanvas';
import AutocompleteInput from './AutocompleteInput';

function SignatureSection({ config, formData, updateFormData, updateInterestedName, usersWithGroups }) {
  const handleChange = (field, value) => {
    console.log(`SignatureSection - handleChange actualizando ${field} con:`, value);
    updateFormData({ [field]: value });
  };

  const handleInterestedNameChange = (name) => {
    console.log('SignatureSection - handleInterestedNameChange llamado con:', name);
    updateFormData({ interestedName: name });
  };

  const handleInterestedSelect = (selectedUser) => {
    console.log('SignatureSection - handleInterestedSelect llamado con:', selectedUser);
    
    // Al seleccionar un usuario, actualizar todos los datos relacionados
    if (selectedUser && selectedUser.name) {
      const updatedData = {
        interestedName: selectedUser.name,
        name: selectedUser.name,
        group: selectedUser.group || '',
        location: selectedUser.location || '',
        lockerNumber: selectedUser.lockerNumber || ''
      };
      
      console.log('SignatureSection - Actualizando datos con:', updatedData);
      updateFormData(updatedData);
    }
  };

  const selectedMeasurer = (config.measurers || []).find(m => m.id === formData.selectedMeasurerId) || 
                         (config.measurers || [])[0];

  return (
    <div className="space-y-3 sm:space-y-4">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
        <div className="p-3 sm:p-4 border border-gray-300 rounded">
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
            NOMBRE Y FIRMA MEDIDOR
          </label>
          <div className="space-y-2">
            {(config.measurers || []).length > 1 && (
              <select 
                value={formData.selectedMeasurerId || (config.measurers || [])[0]?.id || ''}
                onChange={(e) => handleChange('selectedMeasurerId', parseInt(e.target.value))}
                className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 text-sm"
              >
                {(config.measurers || []).map((measurer) => (
                  <option key={measurer.id} value={measurer.id}>
                    {measurer.name}
                  </option>
                ))}
              </select>
            )}
            
            <input 
              type="text" 
              value={selectedMeasurer?.name || ''} 
              readOnly
              className="w-full p-2 bg-gray-100 border border-gray-300 rounded text-xs sm:text-sm"
              placeholder="Configurar en Configuración"
            />
            
            <div className="h-20 sm:h-24 border border-gray-300 rounded bg-gray-50 flex items-center justify-center relative">
              {selectedMeasurer?.signature ? (
                <div className="relative w-full h-full flex items-center justify-center p-2">
                  <img src={selectedMeasurer.signature} alt="Firma del medidor" className="max-h-full max-w-full object-contain" />
                  <div className="absolute bottom-1 right-1">
                    <span className="text-xs text-green-600 bg-white px-1 rounded shadow-sm">✓ Configurada</span>
                  </div>
                </div>
              ) : (
                <div className="text-center">
                  <span className="text-gray-400 text-xs sm:text-sm block">Firma del medidor</span>
                  <span className="text-gray-300 text-xs">(Configurar)</span>
                </div>
              )}
            </div>
          </div>
        </div>
        
        <div className="p-3 sm:p-4 border border-gray-300 rounded">
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
            FECHA
          </label>
          <input 
            type="date" 
            value={formData.date} 
            onChange={(e) => handleChange('date', e.target.value)}
            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 text-sm"
          />
        </div>
      </div>
      
      <div className="p-3 sm:p-4 border border-gray-300 rounded">
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
          NOMBRE Y FIRMA DEL INTERESADO
        </label>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
          <div>
            <AutocompleteInput 
              value={formData.interestedName} 
              onChange={handleInterestedNameChange}
              onSelectUser={handleInterestedSelect}
              placeholder="Nombre del interesado" 
              usersWithGroups={usersWithGroups}
            />
            {formData.group && formData.interestedName === formData.name && (
              <p className="mt-1 text-xs text-green-600">✓ Grupo sincronizado con el nombre seleccionado</p>
            )}
            {(formData.location || formData.lockerNumber) && formData.interestedName === formData.name && (
              <div className="mt-1 text-xs text-green-600">
                {formData.location && <div>✓ Ubicación: {formData.location}</div>}
                {formData.lockerNumber && <div>✓ Taquilla: {formData.lockerNumber}</div>}
              </div>
            )}
          </div>
          <div>
            <SignatureCanvas 
              value={formData.interestedSignature} 
              onChange={(value) => handleChange('interestedSignature', value)}
              placeholder="Firme aquí"
              height="h-20 sm:h-24"
              showPreview={false}
            />
            {formData.interestedSignature && (
              <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded">
                <p className="text-xs text-green-700 font-medium">✓ Firma capturada</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignatureSection;